import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Avatar, Menu, MenuButton, MenuItem, MenuList } from '@parrot/ui';
import { logout } from '../AuthGuard';
import styles from './UserMenu.module.css';

export function UserMenu() {
  const navigate = useNavigate();
  const name = localStorage.getItem('user_name') || 'User';
  const email = localStorage.getItem('user_email') || '';

  /* The @parrot/ui Menu is an uncontrolled popover and MenuList doesn't forward a
     ref, so the open state isn't directly available. The trigger button carries
     `popovertarget` pointing at the list's id; we resolve that popover element and
     listen to its `toggle` event to light up the trigger avatar — the same active
     treatment location-intelligence gives it. */
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    const btn = root?.querySelector('[popovertarget]');
    const targetId = btn?.getAttribute('popovertarget');
    if (!targetId) return;
    const popover = document.getElementById(targetId);
    if (!popover) return;

    const onToggle = (e: Event) => {
      setOpen((e as ToggleEvent).newState === 'open');
    };
    popover.addEventListener('toggle', onToggle);
    return () => popover.removeEventListener('toggle', onToggle);
  }, []);

  const handleLogout = () => {
    const loginPath = logout();
    navigate(loginPath);
  };

  return (
    <div ref={rootRef} className={styles.root}>
      <Menu>
        <MenuButton variant={'ghost'} size={'sm'} className={styles.trigger}>
          <Avatar name={name} size={'sm'} active={open} />
        </MenuButton>

        <MenuList className={styles.list}>
          <div className={styles.profile}>
            <Avatar name={name} size={'lg'} />
            <div className={styles.info}>
              <span className={styles.name}>{name}</span>
              <span className={styles.email}>{email}</span>
            </div>
          </div>

          <div className={styles.separator} />

          <MenuItem tone={'danger'} onSelect={handleLogout}>
            <LogOut size={15} />
            <span>{'Sign out'}</span>
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  );
}
